"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalLoyaltyBehavior = void 0;
const base_1 = require("./base");
/** Loyalty managed inside the platform: no provider call, balance read locally. */
class InternalLoyaltyBehavior extends base_1.LoyaltyBehaviorBase {
    constructor() {
        super(...arguments);
        this.capabilities = {
            usesProviderPoints: false,
            showsInternalLoyaltyData: true,
            supportsEnrollment: false,
            supportsPointsRetry: false,
            // The local credit balance is redeemable, and it *is* the platform display.
            contributesPointsToPayment: true,
            isSoleLoyaltyDisplay: false,
        };
    }
    /** Every customer participates; points come from their local credit balance. */
    loadCustomerLoyalty() {
        return __awaiter(this, void 0, void 0, function* () {
            return { status: 'enrolled', points: null, tier: null };
        });
    }
}
exports.InternalLoyaltyBehavior = InternalLoyaltyBehavior;
//# sourceMappingURL=internal.js.map